import * as actionTypes from '../../actions/BUAP/actionsTypes';

const inititalState = {
    updatecart: 0,
};

const updateCartReducer = (state = inititalState, action) => {
    switch (action.type) {
        case actionTypes.SETUPDATECART:
            return {
                ...state,
                updatecart: action.value
            }
        default:
            return state;
    }
}

export default updateCartReducer;